import React from 'react';
import { Input } from 'antd';
import './ChatInput.css';
import { MicIcon } from '../Icons';
import { ArrowRight } from 'lucide-react';

const { TextArea } = Input;

export default function ChatInput({
    value,
    onChange,
    onSend,
    onToggleRecording,
    isRecording,
    recognizing,
    isSending,
    isFetchingStep,
}) {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (!isSending && !isFetchingStep) {
                onSend(value);
            }
        }
    };

    return (
        <div className="chat-input-container functional">
            <TextArea
                className="chat-textarea"
                placeholder="Tôi muốn đặt xe"
                value={value}
                onChange={onChange}
                onKeyDown={handleKeyDown}
                autoSize={{ minRows: 1, maxRows: 5 }}
                bordered={false}
            />
            <div className="icon-wrapper">
                <button
                    className={`mic-icon-container button ${isRecording ? 'recording' : ''}`}
                    onClick={onToggleRecording}
                    disabled={isSending || isFetchingStep || recognizing}
                    title={isRecording ? "Dừng ghi âm" : "Bắt đầu ghi âm"}
                >
                    <MicIcon />
                </button>
                <button
                    className="send-icon-container button"
                    onClick={() => onSend(value)}
                    disabled={isSending || isFetchingStep || !value.trim()}
                    title="Gửi"
                >
                    <ArrowRight color="#fff" />
                </button>
            </div>
        </div>
    );
}